import React from 'react';
import { Link, Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';

export const TextAlertDisclosure: React.VFC = () => {
  const { classes } = useStyles();
  const l10n = useL10n();

  return (
    <Paper variant="outlined" className={classes.root}>
      <Typography variant="body2" color="textPrimary" className={classes.title} gutterBottom>
        {l10n.phoneValidationModal.textAlertDisclosure.title}
      </Typography>
      <Typography variant="body2" color="textPrimary">
        {l10n.phoneValidationModal.textAlertDisclosure.body} {l10n.phoneValidationModal.textAlertDisclosure.seeOur}{' '}
        <Link href={l10n.general.privacyUrl} color="inherit" underline="always" target="_blank" rel="noreferrer">
          {l10n.general.privacy}
        </Link> and <Link href={l10n.general.termsUrl} color="inherit" underline="always" target="_blank" rel="noreferrer">
          {l10n.general.terms}
        </Link>.
      </Typography>
    </Paper>
  );
};

const useStyles = makeStyles({ name: 'TextAlertDisclosure' })(theme => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.secondary.background,
    borderColor: theme.palette.secondary.border,
  },
  title: {
    fontWeight: 600,
  },
}));
